import { useRoute } from 'shared/src/hooks/useRoute';

export type GoodsRouteParams = {
  RecentlyViewedGoods: {
    instanceId?: string;
  };
  GoodsDetail: {
    instanceId?: string;
    goodsId: number;
    extras?: {
      logging_analytics?: string;
      goods_name: string;
      market_name: string;
      cover_image: string;
      market_image: string;
      discount_rate: number;
      original_price: number;
      price: number;
      from?: string;
      coupon_sno?: number;
    };
  };
};

export const useGoodsRoute = <Key extends keyof GoodsRouteParams>() =>
  useRoute<GoodsRouteParams, Key>();
